import { FETCH_CARS, FETCH_CARS_SUCCESS, FETCH_CARS_FAILED, EDIT_CAR } from "../store/types";
import store from "../store/store";
import { firebase } from "../config/configureFirebase";
import { onValue, update, set, child, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchCars = () => (dispatch) => {
	const { carsRef } = firebase;

	dispatch({
		type: FETCH_CARS,
		payload: null,
	});

	const userInfo = store.getState().auth.profile;

	onValue(carsRef(userInfo.uid, userInfo.usertype), (snapshot) => {
		if (snapshot.val()) {
			let data = snapshot.val();
			const arr = Object.keys(data).map((i) => {
				data[i].id = i;
				return data[i];
			});
			dispatch({
				type: FETCH_CARS_SUCCESS,
				payload: arr,
			});
		} else {
			dispatch({
				type: FETCH_CARS_FAILED,
				payload: store.getState().languagedata.defaultLanguage.no_cars,
			});
		}
	});
};

export const editCar = (car, method) => async (dispatch) => {
	const { singleUserRef, carAddRef, carEditRef, carImage, carDocImageLicense, carDocImageInsurance, carDocImageRoadWorthiness } = firebase;

	dispatch({
		type: EDIT_CAR,
		payload: { method, car },
	});
	if (method === "Add") {
		let carId = push(carAddRef).key;
		set(child(carAddRef, carId), car);
	} else if (method === "Delete") {
		remove(carEditRef(car.id));
	} else if (method === "UpdateImageLicense" || method === "UpdateImageInsurance" || method === "UpdateImageRoadWorthiness") {
		if (method === "UpdateImageLicense") {
			await uploadBytesResumable(carDocImageLicense(car.id), car.car_image);
			const image = await getDownloadURL(carDocImageLicense(car.id));
			update(carEditRef(car.id), { updateAt: new Date().getTime(), doc_image_license: image });
		} else if (method === "UpdateImageInsurance") {
			await uploadBytesResumable(carDocImageInsurance(car.id), car.car_image);
			const image = await getDownloadURL(carDocImageInsurance(car.id));
			update(carEditRef(car.id), { updateAt: new Date().getTime(), doc_image_insurance: image });
		} else if (method === "UpdateImageRoadWorthiness") {
			await uploadBytesResumable(carDocImageRoadWorthiness(car.id), car.car_image);
			const image = await getDownloadURL(carDocImageRoadWorthiness(car.id));
			update(carEditRef(car.id), { updateAt: new Date().getTime(), doc_image_roadworthiness: image });
		}
	} else if (method === "UpdateImage") {
		await uploadBytesResumable(carImage(car.id), car.car_image);
		let image = await getDownloadURL(carImage(car.id));
		let data = car;
		data.car_image = image;
		set(carEditRef(car.id), data);
		if (car.active && car.driver) {
			update(singleUserRef(car.driver), {
				updateAt: new Date().getTime(),
				car_image: image,
			});
		}
	} else {
		set(carEditRef(car.id), car);
	}
};

export const updateUserCarWithImage = (newData, blob) => (dispatch) => {
	const { auth, carAddRef, singleUserRef, carImage } = firebase;

	// console.log("Api", newData);

	var carId = push(carAddRef).key;

	uploadBytesResumable(carImage(carId), blob)
		.then(() => {
			blob.close();
			return getDownloadURL(carImage(carId));
		})
		.then((url) => {
			newData.car_image = url; // Add image URL if upload succeeds
			return set(child(carAddRef, carId), newData);
		})
		.catch((error) => {
			// Remove car_image if upload fails
			delete newData.car_image;

			// Proceed to set data without image
			return set(child(carAddRef, carId), newData);
		})
		.then(() => {
			if (newData.active) {
				let updateData = {
					carType: newData.carType,
					vehicleNumber: newData.vehicleNumber,
					vehicleMake: newData.vehicleMake,
					vehicleModel: newData.vehicleModel,
					other_info: newData.other_info,
					carApproved: newData.approved,
					updateAt: new Date().getTime(),
				};

				// Include car_image only if it exists
				if (newData.car_image) {
					updateData.car_image = newData.car_image;
				}

				return update(singleUserRef(auth?.currentUser?.uid), updateData);
			}
		})
		.catch((error) => {
			console.error("Database Update Error:", error.code, error.message);
		});
};
